import React, { Component } from 'react';
import history from 'dashboard/history';
import PreLoader from 'components/PreLoader/PreLoader.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import Button from 'components/Button/Button.react';
import Fieldset from 'components/Fieldset/Fieldset.react';
import styles from './Styles.scss';
import stylesSettings from 'dashboard/Settings/Settings.scss';

export default class Forgot extends Component {
  state = {
    loading: false,
  }

  onCloseClick() {
    history.push(`/account/info`);
  }

  render() {
    const classes = [stylesSettings.settings_page, stylesSettings.default];

    return (
      <div className={classes.join(' ')}>
        <Toolbar section={this.props.section} subsection={'Forgot'}>
          <Button value='Go Back' onClick={this.onCloseClick} />
        </Toolbar>
        <PreLoader loading={this.state.loading}>
          <div className={stylesSettings.holder}>
            <Fieldset
              legend='Request "to be forgotten" - for erasure of personal data related to me'
            >
              <div className={stylesSettings.settingsBox}>
                <div className={[stylesSettings.infoBox, styles.box].join(' ')}>
                  <p>After you request "to be forgotten" - for erasure of your personal data which is required for maintenance of your registration on SashiDo, your profile will be deactivated.</p>

                  <p>Please, have in mind that the withdrawal of your consent does not affect the legality and validity of any processing of your personal data which has been made prior to the withdrawal.</p>

                  <p>What you need to do:</p>

                  <ol>
                    <li>Download the <a href="http://public-docs.cloudstrap.io/gdpr/forms/exemplary_form_for_request_to_be_forgotten_for_erasure_of_personal_data_related_to_me.pdf" target="_blank" rel='noreferrer noopener'>Exemplary form for request "to be forgotten" - for erasure of personal data related to me</a></li>
                    <li>Send the completed form correctly to support@sashido.io with a subject: <strong>Request "to be forgotten" - for erasure of personal data related to me</strong></li>
                  </ol>

                  <p>What will happen with your account and apps:</p>

                  <ol>
                    <li>You applications will be destroyed and your account will be cancelled.</li>
                    <li>We'll charge your card for the last time if there are any unbilled charges.</li>
                    <li>We'll remove your card and payment details.</li>
                  </ol>

                </div>
              </div>
            </Fieldset>
          </div>
        </PreLoader>
      </div>
    );
  }
}
